import { render, staticRenderFns } from "./ChiefSupervisorReportManagerWrapper.vue?vue&type=template&id=67536fbb&scoped=true&"
import script from "./ChiefSupervisorReportManagerWrapper.vue?vue&type=script&lang=js&"
export * from "./ChiefSupervisorReportManagerWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ChiefSupervisorReportManagerWrapper.vue?vue&type=style&index=0&id=67536fbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67536fbb",
  null
  
)

export default component.exports